// extracted by mini-css-extract-plugin
export default {"wrapper":"UnsupportedChunk-modules__wrapper__liMrd","img":"UnsupportedChunk-modules__img__w7b0h","show-keyframe":"UnsupportedChunk-modules__show-keyframe__tVQ0W"};